import { render, staticRenderFns } from "./DeleteConfirmModal.vue?vue&type=template&id=6a7a6952&"
import script from "./DeleteConfirmModal.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a7a6952')) {
      api.createRecord('6a7a6952', component.options)
    } else {
      api.reload('6a7a6952', component.options)
    }
    module.hot.accept("./DeleteConfirmModal.vue?vue&type=template&id=6a7a6952&", function () {
      api.rerender('6a7a6952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/DeleteConfirmModal.vue"
export default component.exports